module.exports = __webpack_public_path__ + "static/tips-e6ba5b90fe8d401692a662bd7845467c.png";